import React from "react";
import AssessmentSectionSidebar from "./AssessmentSectionSidebar";

// Thin TPRM-flavored wrapper over the shared AssessmentSectionSidebar — keeps this
// component's existing import path/props stable while the implementation lives in one place.
const TPRMSectionSidebar = (props) => (
    <AssessmentSectionSidebar {...props} getQuestionId={(q) => q.tprmQuestionId} />
);

export default TPRMSectionSidebar;
